import { ApiRequestInterceptor } from "./apiRequest";
import { BLOG } from "../constants/endpoints/endpoints";

export const fetchBlog = async () => {
    const response = await ApiRequestInterceptor(BLOG.blog, "GET");
    const { code, data } = response;

    if (code === 200) {
        return { code, data };
    } else {
        throw new Error("Error al obtener datos del blog");
    }
};
